import React, { useState, useEffect } from "react";
import auth from "../auth";
import ReactLoading from "react-loading";
import { useAlert } from "react-alert";
import BlueLogo from "../../Resources/logo-blue.png";
import { PinNumberPage } from "../PinNumberPage";
import { MobileNumberPage } from "../MobileNumberPage";

export const OAuthLogin = (props) => {
  const [mobileNumber, setMobileNumber] = React.useState("");
  const [pinNumber, setPinNumber] = React.useState("");
  const [memberNumber, setMemberNumber] = React.useState(null);
  const [page, setPage] = useState(0);
  const [dob, setDob] = useState(null);
  const [timerCountdown, setTimerCountdown] = useState(null);

  const alert = useAlert();
  const [loading, setLoading] = React.useState(false);

  const [pinFailCounter, setPinFailCounter] = useState(0);

  function activatePinPage() {
    setPage(1);
  }

  function errorAlert() {
    alert.show(
      "Your request currently cannot be processed. Please check if the information your provided was correct and try again.",
      {
        title: "An error has occured",
      }
    );
  }

  async function generateOTP(ev = null) {
    if (ev) {
      ev.preventDefault();
    }
    setLoading(true);

    try {
      await auth.generateOTP(mobileNumber, activatePinPage, errorAlert);
    } catch (exception) {
      console.error(exception);
      errorAlert();
    } finally {
      setLoading(false);
      const timer = Date.now() + 300000;
      setTimerCountdown(timer);
    }
  }

  useEffect(() => {
    if (pinNumber.length === 6) {
      confirmOTP();
    }
  }, [pinNumber]);

  async function confirmOTP(ev = null) {

    if(ev){
      ev.preventDefault();
    }

    setLoading(true);
    let clientID = "";
    let redirectURI = "";
    let parameters = props.location.search.split("?").pop();
    parameters = parameters.split("&");
    parameters.forEach((parameter) => {
      let parameterSplit = parameter.split("=");
      switch (parameterSplit[0]) {
        case "client_id":
          clientID = parameterSplit[1];
          break;
        case "redirect_uri":
          redirectURI = parameterSplit[1];
          break;
        default:
          break;
      }
    });

    redirectURI = decodeURIComponent(redirectURI);
    try {
      const uri = redirectURI;

      const resp = await auth.oauthLogin(
        memberNumber,
        mobileNumber,
        pinNumber,
        dob,
        clientID,
        uri
      );
      if (resp.success) {
        window.location.replace(redirectURI + "?code=" + resp.appCode);

      } 
      else if (resp.message === 'Need Member Number') {
        setPage(2);
      }
      else if (resp.message === 'Need DOB') {
        setPage(3);
      }
      
      else {
        const attempt = pinFailCounter + 1;
        setPinFailCounter(attempt);
        if (pinFailCounter >= 2) {
          alert.show(
            "Your have exceeded the number of allowed attempts for validating your verification code. Please start again",
            {
              title: "An error has occurred",
              closeCopy: "Close",
              onClose: () => {
                window.location.assign("/home");
              },
            }
          );
        }        
        else {
          alert.show(
            "Your request cannot be processed. Please check whether the verification code you provided was correct and try again.",
            {
              title: "An error has occurred",
            }
          );
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="container">
      <div className="overlay" hidden={!loading}>
        <ReactLoading
          className="loading"
          type={"cylon"}
          color={"#61dafb"}
          height={300}
          width={300}
        />
      </div>
      <img alt="Bankstown Logo" className="oauth-image" src={BlueLogo} />

      <div className="mini-form container">
        <h2>
          <strong>LOGIN</strong>
        </h2>
      </div>

      {page === 0 && (
        <>
          <MobileNumberPage
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            generateOTP={generateOTP}
          />
        </>
      )}
      {page === 1 && (
        <PinNumberPage pinNumber={pinNumber} setPinNumber={setPinNumber} timerCountdown={timerCountdown} />
      )}
      {page === 2 && (
        <>
          <img alt="Bankstown Logo" className="oauth-image" src={BlueLogo} />
          <div className="oauth-login-div d-flex justify-content-center">
            <form
              className="oauth-login-form"
              onSubmit={(ev) => confirmOTP(ev)}
            >
              <p className="text-center oauth-login-description">
                We need more information from you.
              </p>
              <p className="login-label">
                <strong>Member Number</strong>
              </p>
              <input
                required
                className="oauth-form-control login-field"
                type="number"
                onChange={(ev) => setMemberNumber(ev.target.value)}
              />
              <button className="form-btn btn btn-primary" type="submit">
                NEXT
              </button>
            </form>
          </div>
        </>
      )}
      {page === 3 && (
        <>
          <div className="oauth-login-div d-flex justify-content-center">
            <form className="oauth-login-form" onSubmit={(ev) => confirmOTP(ev)}>
              <p className="text-center oauth-login-description">
                We need more information from you.
              </p>
              <p className="login-label">
                <strong>Date of Birth</strong>
              </p>
              <input
                required
                className="oauth-form-control login-field"
                type="Date"
                onChange={(ev) => setDob(ev.target.value)}
              />
              <button className="form-btn btn btn-primary" type="submit">
                NEXT
              </button>
            </form>
          </div>
        </>
      )}
    </div>
  );
};
